// extracted by mini-css-extract-plugin
module.exports = {"loading":"LiveNavFavouriteMenuItem_loading__bUEY_","label":"LiveNavFavouriteMenuItem_label__jYBGn"};